import React from 'react';
import {
  Link,
  Stack,
  TableCell, TableRow, Typography,
} from '@material-ui/core';

import { fDate } from '../../../utils';
import { CommonMoreMenu } from '../../../components';
import { ContactMessage } from '../../../types';
import { useOnItemClick } from '../../../hooks/useOnItemClick';

export const ContactUsItem: React.FC<{
  data: ContactMessage,

}> = ({ data }) => {
  const { onItemClick } = useOnItemClick('/dashboard/contact-us', data.id);

  return (
    <TableRow hover sx={{ cursor: 'pointer' }}>
      <TableCell onClick={onItemClick}>{data.id}</TableCell>
      <TableCell onClick={onItemClick}>{data.name}</TableCell>
      <TableCell onClick={onItemClick}>{data.email}</TableCell>
      <TableCell onClick={onItemClick}>{`${data.country}, ${data.city}`}</TableCell>
      <TableCell onClick={onItemClick}>
        <Typography variant="body2" sx={{ wordBreak: 'break-word', maxWidth: 400 }}>
          {data.message}
        </Typography>
      </TableCell>
      <TableCell>
        <Stack direction="column" spacing={1}>
          {data.attachments?.map((att) => (
            <Link
              key={att.id}
              href={att.file}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: 'block', maxWidth: 120, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              }}
            >
              {att.file.split('/').pop()}
            </Link>
          ))}
        </Stack>
      </TableCell>
      <TableCell onClick={onItemClick} sx={{ minWidth: 120 }}>
        {fDate(data.createdAt)}
      </TableCell>
      <TableCell align="right">
        <CommonMoreMenu
          itemId={data.id}
          updatingLink="/dashboard/contact-us"
        />
      </TableCell>
    </TableRow>
  );
};
